import React, { useEffect, useState } from 'react';
import { getUserInfo } from '../user';
import SecuredImage from '../components/SecuredImage';

export default function InboxPage() {
  const [user, setUser] = useState(null);
  const [form, setForm] = useState({});
  const [photoPreview, setPhotoPreview] = useState('');
  useEffect(() => {
    getUserInfo().then((info) => {
      setUser(info);
      setForm({
        email: info?.email || '',
        name: info?.name || '',
      });
      setPhotoPreview(info?.avatar || '');
    });
  }, []);
  function getInitials(u) {
    return u?.initials || '?';
  }
  return (
    <div className="space-y-4 lg:space-y-8 dark:text-gray-100">
      {/* Banner */}
      <div className="relative rounded-lg bg-gradient-to-r from-emerald-400 to-purple-500 p-6 text-center overflow-hidden" style={{ minHeight: '180px' }}>
        <img
          src="/profile-header.png"
          alt="Profile Banner"
          className="absolute inset-0 w-full h-full object-cover object-center pointer-events-none select-none"
          style={{ zIndex: 0 }}
          onError={e => { e.target.style.display = 'none'; }}
        />
        <div className="relative z-10 mb-5 inline-block">
          <div className="rounded-full bg-white/50 p-2">
            {photoPreview ? (
              <SecuredImage
                src={photoPreview}
                alt="User Avatar"
                className="inline-block size-20 rounded-full"
                fallback={
                  <div className="inline-flex size-20 items-center justify-center rounded-full bg-emerald-700 text-2xl font-bold text-white">
                    {getInitials(user)}
                  </div>
                }
              />
            ) : (
              <div className="inline-flex size-20 items-center justify-center rounded-full bg-emerald-700 text-2xl font-bold text-white">
                {getInitials(user)}
              </div>
            )}
          </div>
        </div>
        <h3 className="relative z-10 text-xl font-bold text-white">{form.name || user?.email || 'User'}</h3>
        <h4 className="relative z-10 text-sm font-medium text-white/90">&nbsp;</h4>
      </div>
      {/* END Banner */}
      {/* Inbox Placeholder */}
      <div className="flex flex-col overflow-hidden rounded-lg bg-white shadow-xs dark:bg-gray-800 dark:text-gray-100">
        <div className="grow p-5 md:flex lg:p-8 items-center justify-center min-h-[200px]">
          <div className="w-full text-center">
            <svg className="mx-auto mb-4 size-12 text-emerald-400" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21.75 17.25v-10.5A2.25 2.25 0 0019.5 4.5h-15A2.25 2.25 0 002.25 6.75v10.5m19.5 0A2.25 2.25 0 0119.5 19.5h-15a2.25 2.25 0 01-2.25-2.25m19.5 0v-2.25a.75.75 0 00-.75-.75h-3.818a2.25 2.25 0 01-1.591-.659l-1.182-1.182a2.25 2.25 0 00-1.591-.659h-1.636a2.25 2.25 0 00-1.591.659l-1.182 1.182a2.25 2.25 0 01-1.591.659H3a.75.75 0 00-.75.75v2.25" /></svg>
            <h2 className="text-lg font-semibold mb-2">Inbox</h2>
            <p className="text-gray-500 dark:text-gray-400 mb-4">Your messages and notifications will appear here.</p>
            <div className="text-gray-400">(No messages yet)</div>
          </div>
        </div>
      </div>
      {/* END Inbox Placeholder */}
    </div>
  );
}
